import createReactComponent from '../createReactComponent';
import { IconNode } from '../types';

export const __iconNode: IconNode = [["path",{"d":"M3 7v10l7 4v-18l-7 4","key":"svg-0"}],["path",{"d":"M21 7v10l-7 4v-18l7 4","key":"svg-1"}]]

const IconBrandMetabrainz = createReactComponent('outline', 'brand-metabrainz', 'BrandMetabrainz', __iconNode);

export default IconBrandMetabrainz;